import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

interface SessionTimeoutWarningProps {
  open: boolean;
  secondsLeft: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function SessionTimeoutWarning({
  open,
  secondsLeft,
  onStayLoggedIn,
  onLogout,
}: SessionTimeoutWarningProps) {
  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeStr = minutes > 0 ? `${minutes}:${secs.toString().padStart(2, "0")}` : `${secs}s`;

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10 mb-2">
            <Clock className="h-6 w-6 text-destructive" />
          </div>
          <AlertDialogTitle className="text-center">Session Expiring Soon</AlertDialogTitle>
          <AlertDialogDescription className="text-center space-y-2">
            <p>
              Your session will expire in{" "}
              <span className="font-bold text-destructive text-lg">{timeStr}</span>{" "}
              due to inactivity.
            </p>
            <p>Would you like to stay logged in?</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onLogout} className="gap-2">
            <LogOut className="h-4 w-4" />
            Log Out Now
          </Button>
          <Button onClick={onStayLoggedIn} className="gap-2">
            Stay Logged In
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
